import { MissingDataState } from "molecules/missingDataState/MissingDataState";
import { useGetIntegrationsQuery } from "src/common/service/nexus/nexusApi.ts";
import { useLoadedCompanyDomain } from "src/routes/routeDataHooks.js";
import { useSearchParams } from "react-router";
import { LegalEntityIntegration } from "./LegalEntityIntegration.tsx";
import { QueriesResult } from "molecules/queryResult/QueriesResult";

import {
	useGetErLegalEntitiesQuery,
	useGetIntegrationQuery,
} from "src/common/service/fusionHub/fusionHubApi.ts";
import { skipToken } from "@reduxjs/toolkit/query";
import { useLoadedLegalEntities } from "src/routes/routeDataHooks.ts";
import { isForbiddenError } from "src/common/utils/httpErrors.ts";
import { useTranslation } from "react-i18next";

export const ConnectIntegrationPage = () => {
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();

	const integrationId = searchParams.get("integrationId");
	const autoResolve = searchParams.get("autoResolve");

	const numericIntegrationId = Number(integrationId);
	const hasValidIntegrationId =
		!!integrationId && Number.isFinite(numericIntegrationId);

	const companyDomain = useLoadedCompanyDomain();
	const legalEntities = useLoadedLegalEntities();

	const queries = {
		integrations: useGetIntegrationsQuery({
			companyDomainId: companyDomain.id,
		}),
		integration: useGetIntegrationQuery(
			hasValidIntegrationId
				? { integrationId: numericIntegrationId }
				: skipToken,
		),
		erLegalEntities: useGetErLegalEntitiesQuery(
			hasValidIntegrationId
				? { integrationId: numericIntegrationId, take: 100 }
				: skipToken,
		),
	};

	if (!hasValidIntegrationId) {
		return <MissingDataState />;
	}

	return (
		<QueriesResult
			queries={queries}
			renderError={(error) =>
				isForbiddenError(error) ? (
					<MissingDataState
						title={t("Only administrators can set up data sources")}
						description={t("Ask an administrator of this domain for help.")}
					/>
				) : (
					<MissingDataState />
				)
			}
			render={({ integrations, integration, erLegalEntities }) => {
				return (
					<LegalEntityIntegration
						integrationId={integrationId}
						integration={integration}
						companyDomain={companyDomain}
						integrationLegalEntities={erLegalEntities.items}
						existingIntegrations={integrations}
						legalEntities={legalEntities}
						autoResolve={autoResolve === "true"}
					/>
				);
			}}
		/>
	);
};
